import { Business } from '@monolith/legacy/types/api/business';
import { Brand } from '@monolith/legacy/types/api/brand';
import { Retailer } from '@monolith/legacy/types/api/retailer';
import http from './http';

/**
 * Response interface for GET /api/me endpoint
 * Contains user information and optionally brand/retailer data
 */
export interface MeResponse {
  id: number;
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
  business?: Business;
  brand?: Brand;
  retailer?: Retailer;
  created_at?: string;
  updated_at?: string;
  stripe?: { public_key: string };
  show_requested_information_form?: boolean;
}

export function saveEoriNumber(eori_number: string): Promise<Business> {
  return http()
    .patch(`/api/me/eori`, { eori_number })
    .then((response) => response.data?.data);
}

export function saveStorepage(data: object): Promise<Brand> {
  return http()
    .put(`/api/me/brand/shop-page`, data)
    .then((response) => response?.data?.data);
}

export function updateStorepage(data: object): Promise<Brand> {
  return http()
    .patch(`/api/me/brand/shop-page`, data)
    .then((response) => response?.data?.data);
}

export function getMe(): Promise<MeResponse> {
  return http()
    .get('/api/me')
    .then((response) => response.data?.data);
}
